import axios from "axios";

console.log("MODE :", process.env.VUE_APP_MODE);
console.log("BASE_URL :", process.env.VUE_APP_BASE_URL);

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 60000
});
instance.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    return response;
  },

  function(error) {
    return Promise.reject(error);
  }
);

export default instance;
